module.exports = __webpack_public_path__ + "img/lingdao.bbdac04e.png";